export default {
  // Navigation
  'nav.home': '首页',
  'nav.about': '关于',
  'nav.features': '功能',
  'nav.partners': '合作伙伴',
  'nav.testimonials': '用户评价',
  'nav.login': '登录',
  'nav.portal': '会员门户',
  
  // Hero
  'hero.title': '学习。赚取。购物。兑换。',
  'hero.subtitle': '通过HoneyMoneyUnits (HMU)将您的学习之旅转化为奖励',
  'hero.cta.primary': '开始赚取HMU',
  'hero.cta.secondary': '了解更多',
  
  // Stats
  'stats.activeUsers': '活跃用户',
  'stats.hmuEarned': '已赚取HMU',
  'stats.partners': '合作品牌',
  'stats.rewards': '已兑换奖励',
  
  // Features
  'features.title': 'HoneyJar如何运作',
  'features.learn.title': '学习',
  'features.learn.desc': '完成教育模块并赚取HMU',
  'features.earn.title': '赚取',
  'features.earn.desc': '与合作品牌互动并积累积分',
  'features.shop.title': '购物',
  'features.shop.desc': '浏览独家商品和合作伙伴优惠',
  'features.redeem.title': '兑换',
  'features.redeem.desc': '用您的HMU兑换奖励和产品',
  'features.levelup.title': '升级',
  'features.levelup.desc': '解锁徽章、连胜和独家福利',
  
  // Portal
  'portal.welcome': '欢迎回来',
  'portal.hmuBalance': 'HMU余额',
  'portal.tierProgress': '等级进度',
  'portal.currentStreak': '当前连胜',
  'portal.badges': '已收集徽章',
  'portal.activeMissions': '活跃任务',
  'portal.partnerOffers': '合作伙伴优惠',
  'portal.recommendations': '个性化推荐',
  
  // Missions
  'missions.title': '任务',
  'missions.all': '全部',
  'missions.learning': '学习',
  'missions.affiliate': '联盟',
  'missions.completed': '已完成',
  'missions.active': '活跃任务',
  'missions.completedCount': '已完成',
  'missions.earned': '已赚取HMU',
  'missions.timeInvested': '投入时间',
  'missions.start': '开始任务',
  'missions.continue': '继续',
  'missions.completed.btn': '已完成',
  'missions.referralBonus': '推荐奖励',
  'missions.streakBonus': '连胜奖励',
  
  // Rewards
  'rewards.title': '奖励目录',
  'rewards.all': '全部',
  'rewards.bewear': 'B.E. Wear',
  'rewards.digital': '数字产品',
  'rewards.partner': '合作伙伴优惠',
  'rewards.redeem': '兑换',
  'rewards.locked': '已锁定',
  'rewards.earnCPV': '赚取',
  'rewards.earnCCV': '每次转化',
  'rewards.selectSize': '选择尺寸',
  
  // Auth
  'auth.login': '登录',
  'auth.register': '注册',
  'auth.email': '电子邮件',
  'auth.password': '密码',
  'auth.name': '全名',
  'auth.location': '位置',
  'auth.referralCode': '推荐码（可选）',
  'auth.welcomeBonus': '获得50 HMU欢迎奖励！',
  'auth.optIn.tracking': '我同意活动跟踪',
  'auth.optIn.notifications': '我想接收通知',
  'auth.optIn.partnerOffers': '我想接收合作伙伴优惠',
  'auth.noAccount': '还没有账户？',
  'auth.hasAccount': '已有账户？',
  'auth.signUp': '注册',
  'auth.signIn': '登录',
  
  // Footer
  'footer.tagline': '通过奖励赋能学习',
  'footer.company': '公司',
  'footer.about': '关于我们',
  'footer.careers': '职业',
  'footer.press': '新闻',
  'footer.contact': '联系',
  'footer.resources': '资源',
  'footer.blog': '博客',
  'footer.help': '帮助中心',
  'footer.faq': '常见问题',
  'footer.legal': '法律',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.compliance': '合规',
  'footer.rights': '版权所有',
  'footer.owner': 'Bingham ENT Global Empire',
  
  // Common
  'common.currency': 'HMU',
  'common.days': '天',
  'common.hours': '小时',
  'common.minutes': '分钟',
  'common.loading': '加载中...',
  'common.error': '发生错误',
  'common.success': '成功！',
};